/**
 * ModalStore
 */

Alpine.store("modal", {
    /** 
     * List of rendered modal IDs
     */
    _rendered: [],    

    /**
     * Add a modal ID to the rendered list if not already present.
     */
    add(modalId) {
        if (modalId && !this.has(modalId)) {
            this._rendered.push(modalId);
        }
    },

    /**
     * Check if a modal ID is in the rendered list.
     */
    has(modalId) {
        return this._rendered.includes(modalId);
    },

    /** 
     * Store exit or proceed link for the modal
     */
    _proceedLinks: {},

    /**
     * Set the link reference associated with a given modal ID.
     */
    setProceedLink(link, target, modalId) {
        this._proceedLinks[modalId] = { link, target };
    },

    /** 
     * Used to retrieve the exit or proceed link for the modal.
     */
    getProceedLink(modalId) {
        return this._proceedLinks[modalId]?.link || "#";
    },

    /** 
     * Used to retrieve the exit or proceed link target for the modal.
     */
    getProceedLinkTarget(modalId) {
        return this._proceedLinks[modalId]?.target || "_self";
    }
});